<script setup lang="ts">
import UserDetailsCard from "@/components/dashboard/account/UserDetailsCard.vue";
import { useUserStore } from "@/domains/user/userStore";
import { useDashboardNavStore } from "@/stores/dashboardNavStore";
import { computed } from "vue";

const userStore = useUserStore();
const dashboardNavStore = useDashboardNavStore();

const user = computed(() =>
  userStore.getUsers.find((u) => u.id === dashboardNavStore.displayedUserId),
);
</script>
<template>
  <UserDetailsCard :user="user" />
</template>
